import { render, staticRenderFns } from "./ErrorCard.vue?vue&type=template&id=64519d5f&scoped=true&"
import script from "./ErrorCard.vue?vue&type=script&lang=js&"
export * from "./ErrorCard.vue?vue&type=script&lang=js&"
import style0 from "./ErrorCard.vue?vue&type=style&index=0&id=64519d5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64519d5f",
  null
  
)

export default component.exports